module.exports = __webpack_public_path__ + "img/grade-E.e0ba8802.svg";